import { createAsyncThunk } from "@reduxjs/toolkit";
import { AccountApi, Configuration, LoginRequest } from "api";
import { getBasePath } from "common/getConfiguration";
import { createErrorObject } from "errors/createErrorObject";
import { closeSnackbar, openSnackbar } from "features/ui";
import { getTranslationID } from "translation";

export const loginAsync = createAsyncThunk<
  {
    /* Empty Object */
  },
  LoginRequest,
  {
    // rejectした時の返却値の型
    rejectValue: {
      /* Empty Object */
    };
  }
>("login/loginAsync", async (args, thunkApi) => {
  // apiのConfigurationを取得する
  const basePath = getBasePath();
  const config = new Configuration({ basePath });

  try {
    thunkApi.dispatch(closeSnackbar());
    const accountApi = new AccountApi(config);
    const { data } = await accountApi.login(args);
    return data;
  } catch (e) {
    const error = createErrorObject(e);
    const msg =
      error.errorCode === "E000201"
        ? getTranslationID("loginPage.message.invalidLoginInfo")
        : getTranslationID("common.message.serverInternalError");
    thunkApi.dispatch(
      openSnackbar({
        level: "error",
        message: msg,
      })
    );

    return thunkApi.rejectWithValue({});
  }
});
